
import { defineComponent, ref, reactive, toRefs, onMounted, computed, nextTick, watchEffect, watch, onUnmounted } from 'vue'
import globalsets from '@/utils/globalsets'
import allApi from '@/api/allApi'
export default defineComponent({
  setup() {
    const size = 12
    const pageData: any = reactive({
      fdzqdevData: {},
      fdzqproData: {},
      sylappproData: {}
    })
    // 生产
    const proobj = { OrgCode: 'tc', Token: 'f41659f7-816c-4caf-b3da-8ae5cd39d7cd', AppName: 'tctest', AppVer: 'V3.1.9', AppType: 'ios', Tag: 'mytag123456' }
    const devobj = { OrgCode: 'tc', Token: '22af8018-1e5e-4196-805c-c49e85bae26d', AppName: 'tctest', AppVer: 'V3.1.9', AppType: 'ios', Tag: 'mytag123456' }
    function fdzqdev() {
      allApi.fdzqdevToken(devobj).then((res: any) => {
        pageData.fdzqdevData = res
      })
    }
    function fdzqpro() {
      allApi.fdzqProToken(proobj).then((res: any) => {
        pageData.fdzqproData = res
      })
    }
    function sylapppro() {
      allApi.sylappProToken(proobj).then((res: any) => {
        pageData.sylappproData = res
      })
    }
    return {
      ...toRefs(pageData),
      size,
      fdzqdev,
      fdzqpro,
      sylapppro
    }
  }
})
